import React from 'react'
import { SubmitButton, UndoButton, Columns } from 'labguard-cdk'
import { PageOptionsPortal } from 'src/components/common'
import PropTypes from 'prop-types'

const FormHandlers = ({ children }) => {
  return (
    <PageOptionsPortal justify="space-between">
      <Columns>{children}</Columns>
      <Columns>
        <UndoButton />
        <SubmitButton />
      </Columns>
    </PageOptionsPortal>
  )
}

FormHandlers.propTypes = {
  children: PropTypes.node,
}

export default FormHandlers
